import React from "react";
import { useTranslation } from "react-i18next";
import { IconCircleCheck } from "@tabler/icons-react";

const ImportUserSuccessDialog = ({ open, onClose }) => {
  const { t: getLabel } = useTranslation();

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal modal-blur fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body d-flex flex-column align-items-center justify-content-center" style={{ padding: "32px 16px" }}>
              <IconCircleCheck size={64} color="green" style={{ marginBottom: 16 }} />
              <strong style={{ fontSize: "15px", textAlign: "center" }}>
                {getLabel("TXT_IMPORT_SUCCESS")}
              </strong>
              <p style={{ fontSize: "15px", textAlign: "center", marginBottom: "16px" }}>
                {getLabel("TXT_IMPORT_SUCCESS_MSG")}
              </p>
              <button className="btn btn-primary" style={{ minWidth: "200px" }} onClick={onClose}>
                {getLabel("L_ACCEPT")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportUserSuccessDialog;
